import CareersForm from '@/components/CareersForm'
import EntryHeader from '@/components/EntryHeader'
import FlexibleContent from '@/components/FlexibleContent'
import Main from '@/components/Main'
import Posts from '@/components/Posts'
import SEO from '@/components/SEO'
import styles from '@/styles/pages/_default.module.scss'

export default function Component(props) {
  // Loading state for previews
  if (props.loading) {
    return null
  }

  const metaDesc = props?.data?.page?.seo?.metaDesc
  const { title, featuredImage } = props?.data?.page ?? { title: '' }
  const flexibleContent = props?.data?.page?.template?.flexibleContent?.flexibleContentFields ?? []
  const form = props?.data?.careersForm
  const headerForm = props?.data?.headerForm
  const seoTitle = props?.data?.page?.seo?.title

  return (
    <>
      <SEO title={seoTitle || title} description={metaDesc} imageUrl={featuredImage?.node?.sourceUrl} />

      <EntryHeader pageFields={props?.data?.page} image={featuredImage?.node} form={headerForm} title={title} />

      <Main>
        <FlexibleContent content={flexibleContent} />

        <section className={styles.posts} data-aos="fade-up">
          <Posts posts={props?.data?.posts?.nodes} id="posts-list" />
        </section>
      </Main>

      {form && <CareersForm form={form} />}
    </>
  )
}
